import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Obras';

export interface Obra {
codCentro: string;
codObra: string;
obra: string;
situacion: string;
añoMesCierre: string;
codOferta: string;
centroObra: string;
}

export class ObrasAdapter {
    private cliente: HttpClient;

    constructor() {
        this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
    }

    ListarObras(): AxiosPromise<Obra[]> {
        return this.cliente.get(`/ListarObras`);
    }

    ListarObrasProyecto(idpPoyecto:number): AxiosPromise<Obra[]> {
        return this.cliente.get(`/ListarObras/${idpPoyecto}`);
    }
}